import RouteResetController from 'donor-elf-web/lib/route-reset-controller';
import Changeset from 'ember-changeset';
import { get } from '@ember/object';
import { service } from '@ember/service';
import moment from 'moment';

export default RouteResetController.extend({
  abilities: service(),
  coachingService: service(),

  beforeModel(transition) {
    if (this.abilities.noCoachingAbility('edit_goal_date')) {
      transition.abort();
    }
  },

  model() {
    let individualRecord = this.modelFor(
      'coaching.individuals.individual',
    ).record;
    let goalDate = moment(get(individualRecord, 'goalDate')).format(
      'YYYY-MM-DD',
    );
    let changeset = new Changeset({ goalDate });

    return {
      individualRecord,
      changeset,
    };
  },
});
